"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * NWG.Commerce.Microshop - Api
 * NWG.Commerce.Microshop - Api functionality
 *
 * The version of the OpenAPI document: NWG.Commerce.Microshop - Api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeaturedProductSettingsToJSON = exports.FeaturedProductSettingsFromJSONTyped = exports.FeaturedProductSettingsFromJSON = exports.instanceOfFeaturedProductSettings = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the FeaturedProductSettings interface.
 */
function instanceOfFeaturedProductSettings(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfFeaturedProductSettings = instanceOfFeaturedProductSettings;
function FeaturedProductSettingsFromJSON(json) {
    return FeaturedProductSettingsFromJSONTyped(json, false);
}
exports.FeaturedProductSettingsFromJSON = FeaturedProductSettingsFromJSON;
function FeaturedProductSettingsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'title': !(0, runtime_1.exists)(json, 'title') ? undefined : json['title'],
    };
}
exports.FeaturedProductSettingsFromJSONTyped = FeaturedProductSettingsFromJSONTyped;
function FeaturedProductSettingsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'title': value.title,
    };
}
exports.FeaturedProductSettingsToJSON = FeaturedProductSettingsToJSON;
